module.exports = __webpack_public_path__ + "img/norcott_b1.2ce9b891.jpg";